import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Headphones, ArrowLeft, Home } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F4F4F5] flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center animate-fade-up">
        {/* Logo */}
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#002FA7] text-white mb-6">
          <Headphones className="w-8 h-8" />
        </div>

        {/* 404 */}
        <h1
          className="text-8xl font-bold text-[#002FA7] mb-2"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          404
        </h1>
        <h2
          className="text-2xl font-medium text-[#0F172A] mb-3"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Pagina non trovata
        </h2>
        <p className="text-[#71717A] mb-8">
          La pagina che stai cercando non esiste o è stata spostata.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            className="border-[#E4E4E7] text-[#0F172A] hover:bg-[#F4F4F5]"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Torna indietro
          </Button>
          <Button
            asChild
            className="bg-[#002FA7] hover:bg-[#002FA7]/90 text-white"
          >
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              Vai alla home
            </Link>
          </Button>
        </div>

        <p className="text-center text-xs text-[#71717A] mt-12">
          Powered by IKONET Solutions
        </p>
      </div>
    </div>
  );
}
